import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from '../../../utils/forwardRef.js';
import { COLOR_CLASS } from '../../../../tokens/token-build/js/constants/_color-classes.js';
import styles from './index.module.scss.js';

const VARIANT_MAP = {
    titleLarge: 'h1',
    titleStandard: 'h1',
    headlineRegular: 'h2',
    headlineHeavy: 'h2',
    bodyRegular: 'p',
    bodyHeavy: 'p',
    smallRegular: 'p',
    smallHeavy: 'p',
    xSmallRegular: 'span',
    xSmallHeavy: 'span',
    buttonL: 'span',
    buttonM: 'span',
    buttonNavigation: 'span',
};
const Text = forwardRef(({ as, children, variant = 'bodyRegular', color, 
// TODO: Do not pass on className or style props
// eslint-disable-next-line no-restricted-syntax
className, ...props }, ref) => {
    const Component = as || VARIANT_MAP[variant];
    return (jsx(Component, { ref: ref, className: classNames(className, styles[`qui_text__${variant}`], styles.qui_text, color && COLOR_CLASS[color]), ...props, children: children }));
});
Text.displayName = 'Text';

export { Text };
